import loadJs from '../util/loadJs';

export const couponInit = () => {
  const couponUrl = {
    op: 'https://op-wstatic.plaync.com/nshop/common/nshop_provide.js',
    sb: 'https://sb-wstatic.plaync.com/nshop/common/nshop_provide.js',
    rc: 'https://rc-wstatic.plaync.co.kr/nshop/common/nshop_provide.js',
    live: 'https://wstatic-cdn.plaync.com/nshop/common/nshop_provide.js'
  };

  const href = location.href;
  let lan = 'live';

  if (href.match(/^http[s]?:\/\/(localhost|local)+.*/i)) {
    lan = 'op';
  }
  else if (href.match(/^http[s]?:\/\/(opdev\.|op-|opdev-)+.*/i)) {
    lan = 'op';
  }
  else if (href.match(/^http[s]?:\/\/(sb\.|sb-)+.*/i)) {
    lan = 'sb';
  }
  else if (href.match(/^http[s]?:\/\/(rc\.|rc-)+.*/i)) {
    lan = 'rc';
  }

  if (!window.nshop) {
    loadJs(couponUrl[lan]);
  }

  $(document).on('click.promo.coupon', '[data-coupon]', function(e) {
    e.preventDefault();
    window.nshop.coupon.page();
  });
};

export const coupon = () => {
  window.nshop.coupon.page();
};
